const TASK_PREFERENCES_PATH = "task-preferences";

export const ADSettingsPaths = {
    templates: "templates",
    dispositions: "dispositions",
    tags: "tags",
    cancellationReasons: "cancellation-reasons",
    activityStatuses: "activity-statuses",
    taskPreferences: TASK_PREFERENCES_PATH,
    taskPreferencesForm: `${TASK_PREFERENCES_PATH}/:variant`,
    agentPermissions: "agent-desktop-permissions",
} as const satisfies Record<string, string | ReadonlyArray<string>>;
